'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ActiveCar;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CarHeader = require('./CarHeader.jsx');

var _CarHeader2 = _interopRequireDefault(_CarHeader);

var _CarCompany = require('./CarCompany.jsx');

var _CarCompany2 = _interopRequireDefault(_CarCompany);

var _CarInfoPanel = require('./CarInfoPanel.jsx');

var _CarInfoPanel2 = _interopRequireDefault(_CarInfoPanel);

var _CarTypeDescriptionPanel = require('./CarTypeDescriptionPanel.jsx');

var _CarTypeDescriptionPanel2 = _interopRequireDefault(_CarTypeDescriptionPanel);

var _CarTotalFooter = require('./CarTotalFooter.jsx');

var _CarTotalFooter2 = _interopRequireDefault(_CarTotalFooter);

var _Disclaimer = require('../../../../common/Disclaimer');

var _Disclaimer2 = _interopRequireDefault(_Disclaimer);

var _OptionHeader = require('components/TemplateComponents/common/OptionHeader');

var _OptionHeader2 = _interopRequireDefault(_OptionHeader);

var _emailStyleTools = require('helpers/emailStyleTools');

var _basketHelpers = require('helpers/basketHelpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ActiveCar(_ref) {
  var components = _ref.components,
      option = _ref.option,
      optionNumber = _ref.optionNumber,
      t = _ref.t;

  var styleCarOptionContainer = (0, _emailStyleTools.containerStyles)(components, 'CarOptionContainer');
  var styleCarOptionLabel = (0, _emailStyleTools.textStyles)(components, 'CarOptionLabel');
  var styleCarCommentContainer = (0, _emailStyleTools.containerStyles)(components, 'CarCommentContainer');
  var styleCarComment = (0, _emailStyleTools.textStyles)(components, 'CarComment');

  var optionPrice = (0, _basketHelpers.getDisclaimerText)(option.optionPrice);

  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'ActiveCar' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_OptionHeader2.default, {
            containerStyle: styleCarOptionContainer,
            textStyle: styleCarOptionLabel,
            text: t('common.option') + ' ' + optionNumber
          })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_CarCompany2.default, { components: components, company: (0, _basketHelpers.getCarRentalCompanyName)(option) })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_CarInfoPanel2.default, {
            components: components,
            option: option,
            t: t
          })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_CarTypeDescriptionPanel2.default, { components: components, type: (0, _basketHelpers.getCarTypeDescription)(option) })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_CarTotalFooter2.default, {
            components: components,
            rate: (0, _basketHelpers.getCarRate)(option),
            rateCurrency: (0, _basketHelpers.getCarRateCurrency)(option),
            rateType: (0, _basketHelpers.getCarRateType)(option, t),
            total: (0, _basketHelpers.getCarTotal)(option),
            totalCurrency: (0, _basketHelpers.getCarTotalCurrency)(option),
            rateperdistanceunits: (0, _basketHelpers.getCarRatePerDistanceUnits)(option),
            rateperdistance: (0, _basketHelpers.getCarRatePerDistance)(option),
            rateperdistancecurrency: (0, _basketHelpers.getCarRatePerDistanceCurrency)(option),
            t: t
          })
        )
      ),
      optionPrice && _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_Disclaimer2.default, { padTen: _emailStyleTools.padTen,
            containerStyle: styleCarCommentContainer,
            textStyle: styleCarComment,
            text: optionPrice
          })
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Car/Email/Active/ActiveCar.jsx
// module id = 1494
// module chunks = 0